import { BapiClient } from '@aboutyou/backbone';
import {
  SCAYLE_API_ENDPOINT,
  SCAYLE_API_TOKEN,
  SCAYLE_SHOP_ID,
} from 'src/envVariables';

export const client = (function () {
  if (!SCAYLE_API_ENDPOINT) {
    console.error(`NEXT_PUBLIC_SCAYLE_API_ENDPOINT is not defined`);
  }
  if (!SCAYLE_API_TOKEN) {
    console.error(`NEXT_PUBLIC_SCAYLE_API_TOKEN is not defined`);
  }
  if (!SCAYLE_SHOP_ID) {
    console.error(`NEXT_PUBLIC_SCAYLE_SHOP_ID is not defined`);
  }

  let HOST = SCAYLE_API_ENDPOINT;

  if (typeof window !== 'undefined') {
    /** more info see - https://scayle.dev/en*/
    HOST = `${window.location.origin}/api/s/`;
  }

  return new BapiClient({
    host: HOST,
    shopId: SCAYLE_SHOP_ID,
    shopIdPlacement: 'header',
    auth: {
      type: 'token',
      token: SCAYLE_API_TOKEN,
    },
  });
})();
